var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgControlPlus = function SvgControlPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 41,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#E5E5E5",
    strokeWidth: 0.5,
    d: "M20 .75c10.908 0 19.75 8.842 19.75 19.75S30.908 40.25 20 40.25.25 31.408.25 20.5 9.092.75 20 .75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#125A42",
    strokeWidth: 2,
    d: "M20 10.9v19.2M29.6 20.5H10.4"
  })));
};
export { SvgControlPlus as ReactComponent };
export default __webpack_public_path__ + "images/control-plus.svg";